import { DocumentationValidation } from './DocumentationValidator'
import { ProcedureType } from '@/Domain/Procedures'

const documentsNeeded: { [key: number]: number[] } = {
  1: [1, 2, 3],
  2: [5, 6, 1, 2, 3],
  3: [1, 2, 3],
  4: [1, 2]
}

export class NegociadoDocumentValidator implements DocumentationValidation {
  validateDocuments (userType: number, documents: number[]): boolean {
    if (this.validateUserType(userType) === false) {
      return false
    }
    if (userType === 4) {
      return this.validateForeignCompany(documents)
    }
    return this.validateUserDocuments(userType, documents)
  }

  private validateUserType (userType: number) {
    const validUserTypes = Object.keys(documentsNeeded)
    for (const currentUserType of validUserTypes) {
      if (parseInt(currentUserType, 10) === userType) {
        return true
      }
    }
    return false
  }

  private validateUserDocuments (userType: number, documents: number[]): boolean {
    const userDocumentsNeeded = documentsNeeded[userType]
    const commonDocuments = documents.filter(current => {
      return userDocumentsNeeded.indexOf(current) !== -1
    })
    return commonDocuments.length === userDocumentsNeeded.length
  }

  private validateForeignCompany (documents: number[]): boolean {
    const userDocumentsNeeded = documentsNeeded[4]
    const commonDocuments = documents.filter(current => {
      return userDocumentsNeeded.indexOf(current) !== -1
    })
    const requiredDocumentsPresent = commonDocuments.length === userDocumentsNeeded.length
    const optionalDocumentsPresent = documents.indexOf(7) !== -1 || documents.indexOf(8) !== -1
    return requiredDocumentsPresent && optionalDocumentsPresent
  }

  procedureType (): ProcedureType {
    return ProcedureType.NEGOCIADO
  }
}
